import { calculate } from '@newnetzportal/netzportal-pricing-commons/combined';

function formatRequestObject(request, request_date) {
  return {
    numberOfApartments: request?.number_of_apartments || 1,
    ownContributionSelected: request?.own_contribution_selected || false,
    electricity: request.electricity
      ? formatElParams(request.electricity)
      : null,
    gas: request.gas ? formatGasParams(request.gas, request_date) : null,
    water: request.water ? formatWaterParams(request.water) : null,
  };
}

function formatElParams(electricity) {
  return {
    preferredNetworkConnectionSelected:
      electricity?.preferred_network_connection_selected || false,
    eChargingStationControllableSelected:
      electricity?.e_charging_station_controllable_selected || false,
    businessUnitsPowerRatings: electricity?.business_units_power_ratings || [],
    numberOfEChargingStations: electricity?.number_of_e_charging_stations || 0,
    waterHeatersPowerRating: electricity?.water_heaters_power_rating || 0,
    numberOfWaterHeaters: electricity?.number_of_water_heaters || 0,
    eChargingPowerRating: electricity?.e_charging_power_rating || 0, // in kW
  };
}

function formatGasParams(gas, requestDate) {
  const isGasFree = requestDate
    ? new Date(requestDate) < new Date('2025-12-31T23:00:00.000Z')
    : false;
  return {
    businessUnitsGasRatings: gas?.business_units_gas_ratings || [],
    cookerGasRating:
      gas?.cooker_gas_rating ||
      (gas?.gas_installations?.includes('gas_cooker') ? 10 : 0),
    terraceConnectionGasRating:
      gas?.terrace_connection_gas_rating ||
      (gas?.gas_installations?.includes('terrace_connection') ? 13 : 0),
    heatingGasRating:
      gas?.heating_gas_rating ||
      gas?.heating_hot_water_gas_rating ||
      (gas?.gas_installations?.includes('gas_heating')
        ? 15
        : gas?.gas_installations?.includes('gas_heating_hot_water')
        ? 20
        : 0),
    freeConnection: isGasFree,
  };
}

function formatWaterParams(water) {
  return {
    apartmentUnitsWaterRating: water?.apartment_units_water_ratings || 0,
    businessUnitsWaterRatings: water?.business_units_water_ratings || [],
    waterBuildingCostsRemovedSelected:
      water?.water_building_costs_removed_selected || false,
  };
}

export default {
  getCombinedPricing(request, request_date) {
    const res = calculate(formatRequestObject(request, request_date));
    return res;
  },
};
